import { useEffect, useState } from "react";

import { useTranslate } from "@similarweb/i18n-provider";

import type { ImpactReportPhase } from "../../types/impactReportPhase";

import { PHASE_CHROME } from "./phaseChrome";
import { VisuallyHidden } from "./styles";

type ImpactReportLiveRegionProps = {
    readonly phase: ImpactReportPhase;
};

/**
 * Rendered empty and filled in an effect: the modal mounts per open, so a message present on the
 * first paint arrives in the same commit as the region itself and screen readers, which announce
 * mutations, would skip it — silencing the phase that most needs narrating.
 */
export const ImpactReportLiveRegion = ({ phase }: ImpactReportLiveRegionProps) => {
    const { translate } = useTranslate();
    const [announcement, setAnnouncement] = useState("");

    useEffect(() => {
        setAnnouncement(translate(PHASE_CHROME[phase].announcementKey));
    }, [phase, translate]);

    return (
        <VisuallyHidden
            role="status"
            aria-live="polite"
            data-automation="industry-transition-impact-report-announcer"
        >
            {announcement}
        </VisuallyHidden>
    );
};
